module.exports = __webpack_public_path__ + "static/media/combinationcracks.c1d4ad6b.gif";